import React from 'react';
// import { Row, Col, Image, Space, Typography, Collapse, Grid } from 'antd';
import { Row, Col, Image, Space, Typography, Grid } from 'antd';
import Clay from '../../assets/img/clay-banks-e6pK_snssSY-unsplash.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;
// const { Panel } = Collapse;

function Theme({ content }) {
  const {
    heading = 'Topic',
    items = [
      'The Interconnection Between Occupational Health and Public Health: An Integrated Approach',
      'Intersections of Climate Change, Air Pollution, Public Health, and Social Life',
      'The Future of Work: AI, Precarious Employment, and Public Health',
      'AI-Driven Solutions for Excellent Service in Health, Social Innovation, and Creative Economy Sector',
      'Climate Change and Food Security: Challenges and Solutions',
      'Mental health Issues Caused by AI Utilization: AI Related Mental Health Concerns',
      'Technology Development for Public Safety',
      'Resilient Tourism: Strategies for Pandemic Preparedness and Public Health Protection',
      'Occupational Health as Part of The Environmental Responsibility of Industries',
      'Vulnerable Populations: The Impact of Air Pollution on Pregnant Women and Fetal Development',
      'Interdisciplinary Approaches to Reducing Air Pollution Exposure Among Children and Pregnant Women',
      'The Role of Occupational Health in Managing Non-Communicable Diseases (NCDs)',
      'Integrating Nursing and Midwifery Care Into Public Health System',
      'AI Innovation in Long Term Patient Care Management',
      'AI Applications to Support Clinical Laboratory Accuracy',
    ],
  } = content || {};

  const { xs } = useBreakpoint()
  const safeItems = Array.isArray(items) ? items.filter(Boolean) : []
  const themeIndex = safeItems.findIndex((item) => item.startsWith('Theme:'))
  const resolvedThemeIndex = themeIndex >= 0 ? themeIndex : (safeItems.length ? 0 : -1)
  const themeItem = resolvedThemeIndex >= 0 ? safeItems[resolvedThemeIndex] : ''
  const objectiveItems = safeItems.filter((_, index) => index !== resolvedThemeIndex)
  const splitLabel = (text) => {
    if (!text) return { label: '', body: '' }
    const [label, ...rest] = text.split(':')
    if (rest.length === 0) return { label: '', body: text }
    return { label: label.trim(), body: rest.join(':').trim() }
  }
  const themeParts = splitLabel(themeItem)
  return (
    <React.Fragment>
      {
        xs ?
          <Row className='content-body' justify="space-around" align="middle" gutter={[0,32]} style={{ backgroundColor: '#fff' }}>
            <Col span={24}>
              <Image
                width={'100%'}
                src={Clay}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={24}>
              <Space direction="vertical" size={16}>
                <Space direction="vertical">
                  {/* <Text style={{ fontSize: 20, fontWeight: 'bold' }}>Theme and Topic</Text> */}
                  <Text style={{ fontSize: 20, fontWeight: 'bold' }}>{heading}</Text>
                </Space>
                <Space direction="vertical" size={16}>
                  <Space direction="vertical" size={8}>
                    <Text style={{ fontSize: 16, fontWeight: 'bold' }}>Theme</Text>
                    <Text style={{ fontSize: 16 }}>
                      {themeParts.body || themeParts.label}
                    </Text>
                  </Space>
                  <Space direction="vertical" size={8}>
                    <Text style={{ fontSize: 16, fontWeight: 'bold' }}>Objectives</Text>
                    <ol style={{ marginLeft: -24 }}>
                      {objectiveItems.map((text, index) => {
                        const { label, body } = splitLabel(text)
                        return (
                          <li key={index}>
                            {label ? (
                              <Text style={{ fontSize: 16 }}>
                                <Text strong>{label}:</Text> {body}
                              </Text>
                            ) : (
                              <Text style={{ fontSize: 16 }}>{body}</Text>
                            )}
                          </li>
                        )
                      })}
                    </ol>
                  </Space>
                </Space>
              </Space>
            </Col>
          </Row>
        :
          <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
            <Col span={12}>
              <Image
                width={'100%'}
                src={Clay}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={12}>
              <Space direction="vertical" size={32}>
                <Space direction="vertical" size={-8}>
                  {/* <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Theme and Topic</Text> */}
                  <Text style={{ fontSize: 28, fontWeight: 'bold' }}>{heading}</Text>
                </Space>
                <Row gutter={24}>
                  <Col span={12}>
                    <Space direction="vertical" size={8}>
                      <Text style={{ fontSize: 16, fontWeight: 'bold' }}>Theme</Text>
                      <Text style={{ fontSize: 16 }}>
                        {themeParts.body || themeParts.label}
                      </Text>
                    </Space>
                  </Col>
                  <Col span={12}>
                    <Space direction="vertical" size={8}>
                      <Text style={{ fontSize: 16, fontWeight: 'bold' }}>Objectives</Text>
                      <ol style={{ marginLeft: -24 }}>
                        {objectiveItems.map((text, index) => {
                          const { label, body } = splitLabel(text)
                          return (
                            <li key={index}>
                              {label ? (
                                <Text style={{ fontSize: 16 }}>
                                  <Text strong>{label}:</Text> {body}
                                </Text>
                              ) : (
                                <Text style={{ fontSize: 16 }}>{body}</Text>
                              )}
                            </li>
                          )
                        })}
                      </ol>
                    </Space>
                  </Col>
                </Row>
              </Space>
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Theme